<template>
  <div v-if="getText" :style="`background: ${getBgColor}`"
       class="rounded-full flex items-center px-2 py-1">
    <span class="text-white text-xs">{{ getText }}</span>
  </div>
</template>

<script setup>

const props = defineProps({
  tag: {
    type: Object,
    default: () => {
    }
  },
  selectedOption: {
    type: Object,
    default: () => null
  }
})

const getBgColor = computed(() => !!props.selectedOption ? props.selectedOption?.tag?.background_color : props.tag?.background_color)
const getText = computed(() => !!props.selectedOption ? props.selectedOption?.tag?.text : props.tag?.text)
</script>